import { Request, errorCode } from 'mroshopcommon/src/utils/request';
import Auth from './auth';
import PortalAuth from './portalAuth';
import { userInfo } from '@/stores/userInfo';
import { appInfo } from '@/stores/appInfo';
// import { ccdke } from './cookiesKey';
// Auth.getTokenByKey(ccdke);
const isRelogin = {
  show: false,
};

// 系统 API 配置
export const API_CONFIG = {
  CLOUD: {
    development: 'https://gw-t.zhidiancloud.com',
    production: import.meta.env.VITE_APP_PORTAL_BASE_API,
  },
  MRO: {
    development: 'https://mro-gw-t.zhidiancloud.com',
    production: import.meta.env.VITE_APP_BASE_API,
  },
};

// 获取动态 baseURL 的函数
export const getBaseURL = (apiType: 'CLOUD' | 'MRO' = 'MRO') => {
  const env = import.meta.env.VITE_APP_ENV || 'development';
  const config = API_CONFIG[apiType];

  if (!config) {
    console.warn(`未找到 API 配置: ${apiType}`);
    return API_CONFIG.MRO[env];
  }

  return config[env] || config.development;
};

// 创建请求实例的函数
export const createRequest = (apiType: 'CLOUD' | 'MRO' = 'MRO') => {
  return new Request({
    baseURL: getBaseURL(apiType),
    interceptors: {
      requestInterceptors(config) {
        const isToken = (config.headers || {}).isToken === false;
        // console.log('config?.headers?.token;: ', config?.headers?.token);
        if ((config?.headers?.token || Auth.getToken()) && !isToken && apiType === 'MRO') {
          config.headers['Authorization'] = 'Bearer ' + (config?.headers?.token || Auth.getToken()); // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        if ((config?.headers?.token || PortalAuth.getToken()) && !isToken && apiType === 'CLOUD') {
          config.headers['Authorization'] = 'Bearer ' + (config?.headers?.token || PortalAuth.getToken()); // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        // 用于在注册的时候进行认证的时候带入token
        if (config.headers.registerAuthorization) {
          config.headers['Authorization'] = 'Bearer ' + config.headers.registerAuthorization;
        }
        return config;
      },
      responseInterceptors(res) {
        const userStore = userInfo();
        const appStores = appInfo();
        // 未设置状态码则默认成功状态
        const code: number = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode.default;
        // 二进制数据则直接返回
        if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
          return res.data;
        }
        if (code === 401) {
          if (!isRelogin.show) {
            isRelogin.show = true;
            modal
              .confirmWithOptions('登录状态已过期，您可以继续留在该页面，或者重新登录', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning',
              })
              .then(() => {
                isRelogin.show = false;
                userStore.LogOut().then(() => {
                  appStores.changeInner('/login');
                });
              })
              .catch(() => {
                isRelogin.show = false;
              });
          }
          return Promise.reject('无效的会话，或者会话已过期，请重新登录。');
        } else if (code === 500) {
          modal.msgError(msg);
          return Promise.reject(msg);
        } else if (code !== 200 && code < 10000) {
          modal.notifyError(msg);
          return Promise.reject('error');
        } else {
          if (code >= 10000) {
            modal.notifyError(msg);
          }
          return Promise.resolve(res.data);
        }
      },
    },
  });
};

// 默认导出 MRO 类型的请求实例
export default createRequest('MRO');

// 导出 CLOUD 类型的请求实例
export const cloudRequest = createRequest('CLOUD');
